import { ProtobufAnyMessage } from '@/types'

export function parseProposalJsonMessages(
  rawJsonText: string,
): ProtobufAnyMessage[] {
  let parsedJson: unknown

  try {
    parsedJson = JSON.parse(rawJsonText)
  } catch {
    throw new Error('Invalid JSON')
  }

  if (!parsedJson || typeof parsedJson !== 'object') {
    throw new Error("Field 'messages' must be an array")
  }

  const messages = (parsedJson as { messages?: unknown }).messages

  if (!Array.isArray(messages)) {
    throw new Error("Field 'messages' must be an array")
  }

  const containsInvalidMessage = messages.some(message => {
    if (!message || typeof message !== 'object') return true

    const typeUrl = (message as { '@type'?: unknown })['@type']
    return typeof typeUrl !== 'string' || typeUrl.trim().length === 0
  })

  if (containsInvalidMessage) {
    throw new Error('Each message must contain @type')
  }

  return messages as ProtobufAnyMessage[]
}
